import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { IdentityProvider } from './providers/IdentityProvider';
import { MeshProvider } from './providers/MeshProvider';
import BannerProvider from './providers/BannerProvider';
import ComposerPrefillProvider from './providers/ComposerPrefillProvider';
import { ToastProvider } from './components';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <IdentityProvider>
        {/* ToastProvider must sit ABOVE MeshProvider: MeshProvider reads
            ToastContext to surface transfer feedback ("Peer not connected",
            size / concurrency caps). When it was nested below, showToast was a
            no-op and every Beam failure looked like "nothing happened". */}
        <ToastProvider>
          <MeshProvider>
            <BannerProvider>
              <ComposerPrefillProvider>
                <App />
              </ComposerPrefillProvider>
            </BannerProvider>
          </MeshProvider>
        </ToastProvider>
      </IdentityProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
